"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const vue_3 = require("vue");
const vue_router_1 = require("vue-router");
const tyre_search_1 = require("../../components/ProductSearch/tyre-search");
const TyreFilter_vue_1 = __importDefault(require("../../components/ProductSearch/TyreFilter.vue"));
const forms_1 = require("../../components/ProductSearch/forms");
const DropdownInput_vue_1 = __importDefault(require("../../components/Form/DropdownInput/DropdownInput.vue"));
const DropdownInputItem_1 = __importDefault(require("../../components/Form/DropdownInput/DropdownInputItem"));
const i18n_1 = require("../../common/i18n");
const productFilterStore_1 = require("../../stores/product/filter/productFilterStore");
exports.default = (0, vue_1.defineComponent)({
    __name: 'ProductTubesAndTapes',
    setup(__props) {
        const route = (0, vue_router_1.useRoute)();
        const productFilterStore = (0, productFilterStore_1.useProductFilterStore)();
        const selectedCategory = (0, vue_3.ref)("230");
        const currentType = (0, vue_3.ref)("tube");
        const mainCategoryItems = (0, vue_3.ref)([
            new DropdownInputItem_1.default("210", `<i class="marso-icon-agri"></i> ${(0, i18n_1.trans)("agricultural_tubes", "Agricultural tubes", "tube_filter")}`),
            new DropdownInputItem_1.default("220", `<i class="marso-icon-truck"></i> ${(0, i18n_1.trans)("truck_tubes", "Truck tubes", "tube_filter")}`),
            new DropdownInputItem_1.default("230", `<i class="marso-icon-cargo"></i> ${(0, i18n_1.trans)("van_tubes", "VAN tubes", "tube_filter")}`),
            new DropdownInputItem_1.default("240", `<i class="marso-icon-car"></i> ${(0, i18n_1.trans)("passenger_tubes", "Passenger tubes", "tube_filter")}`),
            new DropdownInputItem_1.default("250", `<i class="marso-icon-forklift"></i> ${(0, i18n_1.trans)("forklift_tubes", "Forklift tubes", "tube_filter")}`),
            new DropdownInputItem_1.default("260", `<i class="marso-icon-dump"></i> ${(0, i18n_1.trans)("work_machine_tubes", "Work machine tubes", "tube_filter")}`),
            new DropdownInputItem_1.default("270", `<i class="marso-icon-moto"></i> ${(0, i18n_1.trans)("motorcycle_tubes", "Motorcycle tubes", "tube_filter")}`),
            new DropdownInputItem_1.default("280", `${(0, i18n_1.trans)("bicycle_tubes", "Bicycle tubes", "tube_filter")}`),
            new DropdownInputItem_1.default("310", `<i class="marso-icon-agri"></i> ${(0, i18n_1.trans)("agricultural_tapes", "Agricultural tapes", "tape_filter")}`),
            new DropdownInputItem_1.default("320", `<i class="marso-icon-truck"></i> ${(0, i18n_1.trans)("truck_tapes", "Truck tapes", "tape_filter")}`),
            new DropdownInputItem_1.default("350", `<i class="marso-icon-forklift"></i> ${(0, i18n_1.trans)("forklift_tapes", "Forklift tapes", "tape_filter")}`),
            new DropdownInputItem_1.default("360", `<i class="marso-icon-dump"></i> ${(0, i18n_1.trans)("work_machine_tapes", "Work machine tapes", "tape_filter")}`),
            new DropdownInputItem_1.default("370", `<i class="marso-icon-moto"></i> ${(0, i18n_1.trans)("motorcycle_tapes", "Motorcycle tapes", "tape_filter")}`),
        ]);
        const brandDropdownInputItems = (0, vue_3.computed)(() => productFilterStore.brandDropdownInputItems);
        const filterValues = (0, vue_3.computed)(() => productFilterStore.productFilters);
        const initForm = (mainCategory) => {
            let type = (0, forms_1.calculateTypeFromAxCategory)(mainCategory);
            currentType.value = type;
            let _form = { axCategory: [mainCategory] };
            if ("tube" == type) {
                _form = Object.assign(forms_1.tubeProductSearchForm, _form);
            }
            if ("tape" == type) {
                _form = Object.assign(forms_1.tapeProductSearchForm, _form);
            }
            return _form;
        };
        let form = (0, vue_3.ref)(Object.assign({}));
        form.value = Object.assign(form.value, initForm(selectedCategory.value));
        const initQueryParams = (0, tyre_search_1.getQueryParams)(form.value, route);
        for (const key in initQueryParams) {
            if (initQueryParams.hasOwnProperty(key)) {
                if (key === "axCategories") {
                    selectedCategory.value = initQueryParams[key][0];
                    form.value['axCategory'] = initQueryParams[key];
                }
                if (key === "type") {
                    currentType.value = initQueryParams[key];
                }
                form.value[key] = initQueryParams[key];
            }
        }
        (0, vue_3.watch)(() => selectedCategory.value, (mainCategory) => {
            for (const key in form.value) {
                if (form.value.hasOwnProperty(key)) {
                    if (key === "axCategory") {
                        form.value.axCategory = [mainCategory];
                        continue;
                    }
                    if (key === "type") {
                        currentType.value =
                            (0, forms_1.calculateTypeFromAxCategory)(mainCategory);
                        form.value[key] = currentType.value;
                        continue;
                    }
                    form.value[key] = null;
                }
            }
        });
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(TyreFilter_vue_1.default, {
                searchLabel: (0, vue_2.unref)(i18n_1.trans)('tube_search', 'Tube search', 'tube_search'),
                form: (0, vue_2.unref)(form),
                "need-tag-search": false,
                category: currentType.value
            }, {
                filtersPrepend: (0, vue_2.withCtx)(() => [
                    (0, vue_2.createVNode)(DropdownInput_vue_1.default, {
                        placeholder: (0, vue_2.unref)(i18n_1.trans)('category', 'Category', 'search_form'),
                        items: mainCategoryItems.value,
                        modelValue: selectedCategory.value,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((selectedCategory).value = $event)),
                        "disable-deselect": ""
                    }, null, 8, ["placeholder", "items", "modelValue"])
                ]),
                defaultFilters: (0, vue_2.withCtx)(() => {
                    var _a, _b, _c;
                    return [
                        (0, vue_2.createVNode)(DropdownInput_vue_1.default, {
                            placeholder: (0, vue_2.unref)(i18n_1.trans)('width', 'Width', 'tyre_filter'),
                            items: (_a = (0, vue_2.unref)(filterValues)) === null || _a === void 0 ? void 0 : _a.widths.values,
                            modelValue: (0, vue_2.unref)(form).width,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => (((0, vue_2.unref)(form).width) = $event))
                        }, null, 8, ["placeholder", "items", "modelValue"]),
                        (0, vue_2.createVNode)(DropdownInput_vue_1.default, {
                            placeholder: (0, vue_2.unref)(i18n_1.trans)('diameter', 'Diameter', 'tyre_filter'),
                            items: (_b = (0, vue_2.unref)(filterValues)) === null || _b === void 0 ? void 0 : _b.diameters.values,
                            modelValue: (0, vue_2.unref)(form).diameter,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => (((0, vue_2.unref)(form).diameter) = $event))
                        }, null, 8, ["placeholder", "items", "modelValue"]),
                        (0, vue_2.createVNode)(DropdownInput_vue_1.default, {
                            placeholder: (0, vue_2.unref)(i18n_1.trans)('brand', 'Brand', 'tyre_filter'),
                            items: (0, vue_2.unref)(brandDropdownInputItems),
                            modelValue: (0, vue_2.unref)(form).brandCode,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => (((0, vue_2.unref)(form).brandCode) = $event))
                        }, null, 8, ["placeholder", "items", "modelValue"]),
                        ('tube' == currentType.value)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(DropdownInput_vue_1.default, {
                                key: 0,
                                placeholder: (0, vue_2.unref)(i18n_1.trans)('valve_type', 'Valve type', 'tube_filter'),
                                items: (_c = (0, vue_2.unref)(filterValues)) === null || _c === void 0 ? void 0 : _c.valveTypes.values,
                                modelValue: (0, vue_2.unref)(form).valveType,
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => (((0, vue_2.unref)(form).valveType) = $event))
                            }, null, 8, ["placeholder", "items", "modelValue"]))
                            : (0, vue_2.createCommentVNode)("", true)
                    ];
                }),
                _: 1
            }, 8, ["searchLabel", "form", "category"]));
        };
    }
});
